import { AuthStorage } from "utils/auth-storage";
import React, { useEffect, useMemo, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { FilePdfOutlined } from "@ant-design/icons";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { CompanyAdminServices } from "apis/Services/CompanyAdminService";

const FALLBACK_LOGO_BASE64 =
  "data:image/png;base64,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";

const EMPTY_STATUS_COUNTS = {
  draft: 0,
  pending: 0,
  overdue: 0,
  completed: 0,
};

function buildExportProjectDetails({
  alignedData,
  approvalTime,
  exportRows,
  projectAddress,
  projectInfo,
  reviewTime,
}) {
  const content = {};
  const divisionsProgress = {};

  let currentDivision = null;
  let currentSubdivision = null;

  const ensureDivisionContent = (divisionRow) => {
    const divisionTitle = divisionRow?.displayTitle;

    if (!divisionTitle) {
      return "";
    }

    if (!content[divisionTitle]) {
      content[divisionTitle] = {};
    }

    if (!divisionsProgress[divisionTitle]) {
      divisionsProgress[divisionTitle] = {
        ...EMPTY_STATUS_COUNTS,
        ...(divisionRow?.summaryCounts || {}),
      };
    }

    return divisionTitle;
  };

  (exportRows || []).forEach((row) => {
    if (row?.rowType === "division") {
      currentDivision = row;
      currentSubdivision = null;
      ensureDivisionContent(row);
      return;
    }

    if (row?.rowType === "subdivision") {
      currentSubdivision = row;
      const divisionTitle = ensureDivisionContent(currentDivision);
      const subdivisionTitle = row?.displayTitle;

      if (divisionTitle && subdivisionTitle && !content[divisionTitle][subdivisionTitle]) {
        content[divisionTitle][subdivisionTitle] = [];
      }

      return;
    }

    if (
      row?.rowType !== "submittal" ||
      !currentDivision?.displayTitle ||
      !currentSubdivision?.displayTitle
    ) {
      return;
    }

    const divisionTitle = ensureDivisionContent(currentDivision);
    const subdivisionTitle = currentSubdivision.displayTitle;

    if (!content[divisionTitle][subdivisionTitle]) {
      content[divisionTitle][subdivisionTitle] = [];
    }

    content[divisionTitle][subdivisionTitle].push({
      ...row,
      childGroup: (row.treeDepth || 0) > 0,
      parentGroup: Boolean(row.hasChildren),
    });
  });

  return {
    approvalTime,
    content,
    divisionsProgress,
    projectAddress,
    projectInfo,
    reviewTime,
    viewsInfo: {
      alignedData: alignedData || {},
    },
  };
}

function formatExportDate(value) {
  if (!value) {
    return value;
  }

  if (moment(value, "YYYY-MM-DD", true).isValid()) {
    return moment(value).format("MM-DD-YYYY");
  }

  return value;
}

function resolveEntryOriginMarker(value) {
  if (value === "Koncurent") {
    return "**KONCURENT-TYPE**";
  }

  if (value === "Procore") {
    return "**PROCORE-TYPE**";
  }

  return "**EX-PROCORE-TYPE**";
}

function ExportProcurementLogPdf({
  alignedData,
  exportRows,
  nestSubmittals,
  projectAddress,
  projectInfo,
  projectsAccessLevelValue,
  approvalTime,
  reviewTime,
}) {
  const { company_id } = useParams();
  const [isExporting, setIsExporting] = useState(false);
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const code = AuthStorage.getItem("token");
    const loginEmail = AuthStorage.getItem("email");

    CompanyAdminServices.getCompanyLogo({
      company_id,
      loginEmail,
      code,
    })
      .then((response) => {
        if (!(response instanceof Blob)) {
          setLogoBase64(null);
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoBase64(reader.result);
        };
        reader.readAsDataURL(response);
      })
      .catch((error) => {
        console.error("Fetching logo failed:", error);
        setLogoBase64(null);
      });
  }, [company_id]);

  const exportProjectDetails = useMemo(
    () =>
      buildExportProjectDetails({
        alignedData,
        approvalTime,
        exportRows,
        projectAddress,
        projectInfo,
        reviewTime,
      }),
    [
      alignedData,
      approvalTime,
      exportRows,
      projectAddress,
      projectInfo,
      reviewTime,
    ],
  );

  const hasExportStructure = useMemo(
    () =>
      Object.keys(exportProjectDetails?.content || {}).length > 0,
    [exportProjectDetails],
  );

  const printTable = (projectsDetails) => {
    const normalizedApprovalTime = Number(projectsDetails?.approvalTime) || 14;
    const normalizedReviewTime = Number(projectsDetails?.reviewTime) || 14;
    const leadTime = 2;
    const resolvedProjectInfo = projectsDetails?.projectInfo || projectInfo || "";
    const resolvedProjectAddress =
      projectsDetails?.projectAddress || projectAddress || "";
    const resolvedAlignedData = projectsDetails?.viewsInfo?.alignedData || {};

    const doc = new jsPDF("landscape");
    const totalPagesExp = "{total_pages_count_string}";

    doc.setFont("helvetica", "normal");

    const currentTimestamp = new Date();
    const month = currentTimestamp.getMonth() + 1;
    const day = currentTimestamp.getDate();
    const year = currentTimestamp.getFullYear();
    const hours = currentTimestamp.getHours();
    const minutes = currentTimestamp.getMinutes();
    const formattedDate = `${month < 10 ? "0" : ""}${month}-${
      day < 10 ? "0" : ""
    }${day}-${year}`;
    const formattedTime = `${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;
    const timeZoneAbbreviation = new Intl.DateTimeFormat("en-US", {
      timeZoneName: "short",
    })
      .formatToParts(currentTimestamp)
      .find((part) => part.type === "timeZoneName")?.value;
    const timestamp =
      `${formattedDate} ${formattedTime} ${timeZoneAbbreviation || ""}`.trim();

    const divisionOptions = {
      margin: { top: 30, right: 5, middle: 0, left: 5 },
      headStyles: {
        halign: "center",
        fontSize: 8,
        fillColor: [220, 228, 245],
      },
      columnStyles: {
        0: { cellWidth: 70, fontSize: 14 },
        1: { cellWidth: 10 },
        2: { cellWidth: 10 },
        3: { cellWidth: 10 },
      },
      didParseCell(data) {
        if (data.section === "head" && data.column.index === 0) {
          data.cell.styles.fontSize = 10;
          data.cell.styles.halign = "left";
        }
      },
    };

    const tableOptions = {
      margin: { top: 30, right: 5, bottom: 10, left: 5 },
      headStyles: {
        halign: "center",
        valign: "middle",
        fontSize: 4,
        fillColor: [68, 99, 159],
      },
      bodyStyles: {
        textColor: 0,
        fontSize: 4,
        overflow: "ellipsize",
        halign: "center",
        valign: "middle",
        cellWidth: "wrap",
      },
      columnStyles: {
        0: { cellWidth: 1, halign: "center", fontSize: 2 },
        1: {
          cellWidth: 25,
          halign: "left",
          fontSize: 4,
          whiteSpace: "nowrap",
          overflow: "linebreak",
        },
        2: { cellWidth: 15, halign: "left", fontSize: 4 },
      },
      didDrawPage(data) {
        const imageToUse = logoBase64 || FALLBACK_LOGO_BASE64;
        let imgWidth = 33;
        let imgHeight = 4;

        if (logoBase64) {
          imgWidth = 30;
          imgHeight = 10;
        }

        if (imageToUse) {
          doc.addImage(
            imageToUse,
            "PNG" || "JPEG",
            data.settings.margin.left,
            10,
            imgWidth,
            imgHeight,
          );
        }

        let pageLabel = `Page ${doc.internal.getNumberOfPages()}`;
        if (typeof doc.putTotalPages === "function") {
          pageLabel = `${pageLabel} of ${totalPagesExp}`;
        }

        doc.setFontSize(8);
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(pageLabel, data.settings.margin.left + 270, pageHeight - 5);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Procurement Log", 150, 15, {
          align: "center",
        });

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(resolvedProjectInfo, 290, 10, {
          align: "right",
        });
        doc.text(resolvedProjectAddress, 290, 15, {
          align: "right",
        });
        doc.text(`Exported on: ${timestamp}`, 290, 20, {
          align: "right",
        });
      },
      didParseCell(data) {
        if (data.section === "head" && data.row.index === 0) {
          data.cell.styles.fontSize = 6;
        }
        if (data.section === "head" && data.row.index === 1) {
          data.cell.styles.fontSize = 5;
          data.cell.styles.fillColor = [44, 76, 129];
        }
        if (
          data.section === "body" &&
          nestSubmittals === 1 &&
          data.cell.text.some((status) => status.includes("colorRowToGrey**"))
        ) {
          data.cell.text = data.cell.text.map((status) =>
            status.replace("colorRowToGrey**", ""),
          );
        }
        if (
          data.section === "body" &&
          nestSubmittals === 1 &&
          data.cell.text.some((status) => status.includes("addIndentation**"))
        ) {
          Object.values(data.row.cells).forEach((cell, index) => {
            if (index > 0) {
              cell.styles.fillColor = [245, 245, 245];
            }
          });

          data.cell.text = data.cell.text.map((status) =>
            status.replace("addIndentation**", "  "),
          );
        }

        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("**KONCURENT-TYPE**"))
        ) {
          data.cell.styles.fillColor = "#0195D9";
          data.cell.text = data.cell.text.map((status) =>
            status.replace("**KONCURENT-TYPE**", ""),
          );
          data.cell.styles.textColor = "#0195D9";
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("**PROCORE-TYPE**"))
        ) {
          data.cell.styles.fillColor = "#FF5201";
          data.cell.text = data.cell.text.map((status) =>
            status.replace("**PROCORE-TYPE**", ""),
          );
          data.cell.styles.textColor = "#FF5201";
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) =>
            status.includes("**EX-PROCORE-TYPE**"),
          )
        ) {
          data.cell.styles.fillColor = "#D32F2F";
          data.cell.text = data.cell.text.map((status) =>
            status.replace("**EX-PROCORE-TYPE**", ""),
          );
          data.cell.styles.textColor = "#FF5201";
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("PENDING"))
        ) {
          data.cell.styles.fillColor = [236, 151, 0];
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("OVERDUE"))
        ) {
          data.cell.styles.fillColor = "red";
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("applyPending"))
        ) {
          data.cell.styles.fillColor = [236, 151, 0];
          data.cell.text = data.cell.text.map((status) =>
            status.replace("applyPending", ""),
          );
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("applyLate"))
        ) {
          data.cell.styles.fillColor = "red";
          data.cell.text = data.cell.text.map((status) =>
            status.replace("applyLate", ""),
          );
        }
        if (
          data.section === "body" &&
          data.cell.text.some((status) => status.includes("ProjectedLATE"))
        ) {
          data.cell.styles.fillColor = "red";
          data.cell.text = data.cell.text.map((status) =>
            status.replace("ProjectedLATE", ""),
          );
        }
      },
      theme: "grid",
    };

    const valuesArray = Object.keys(
      projectsDetails?.divisionsProgress || {},
    ).map((item) => projectsDetails?.divisionsProgress?.[item]);

    function checkDueDate(date) {
      const currentDate = moment();
      const targetDate = moment(date, "MM-DD-YYYY");

      currentDate.startOf("day");
      targetDate.startOf("day");

      const dayDifference = targetDate.diff(currentDate, "days");
      if (dayDifference > 7) {
        return "";
      } else if (dayDifference > 0) {
        return "PENDING";
      } else {
        return "OVERDUE";
      }
    }

    function checkProjectedDeliveryDate(dateOne, dateTwo) {
      const projectedDeliveryDate = moment(dateOne, "MM-DD-YYYY");
      const dateRequiredOnSite = moment(dateTwo, "MM-DD-YYYY");
      if (projectedDeliveryDate.isAfter(dateRequiredOnSite)) {
        return `${dateOne} ProjectedLATE`;
      }
      return `${dateOne}`;
    }

    let divisionIndex = 0;
    for (const key of Object.keys(projectsDetails?.content || {})) {
      const currentDivisionCounts =
        valuesArray[divisionIndex] || EMPTY_STATUS_COUNTS;

      autoTable(doc, {
        head: [
          [
            {
              content: key,
              colSpan: 15,
              styles: {
                textColor: "Black",
              },
            },
            {
              content: `Draft: ${currentDivisionCounts.draft || 0}`,
              colSpan: 1,
              styles: {
                textColor: "gray",
                valign: "middle",
              },
            },
            {
              content: `Pending: ${currentDivisionCounts.pending || 0}`,
              colSpan: 1,
              styles: {
                textColor: [236, 151, 0],
                valign: "middle",
              },
            },
            {
              content: `Overdue: ${currentDivisionCounts.overdue || 0}`,
              colSpan: 1,
              styles: {
                textColor: "red",
                valign: "middle",
              },
            },
            {
              content: `Completed: ${currentDivisionCounts.completed || 0}`,
              colSpan: 1,
              styles: {
                textColor: [1, 149, 217],
                valign: "middle",
              },
            },
          ],
        ],
        ...divisionOptions,
      });

      divisionIndex += 1;

      for (
        let subdivisionIndex = 0;
        subdivisionIndex <
        Object.keys(projectsDetails?.content?.[key] || {}).length;
        subdivisionIndex += 1
      ) {
        const subdivision = Object.entries(
          projectsDetails?.content?.[key] || {},
        )[subdivisionIndex]?.[1];

        const subdivisionData = [];

        for (
          let itemIndex = 0;
          itemIndex < (subdivision || []).length;
          itemIndex += 1
        ) {
          const dataObject = subdivision[itemIndex];
          const dataArray = {
            entryOrigin: resolveEntryOriginMarker(dataObject?.entryOrigin),
            specTitle: dataObject?.specTitle,
            specNumber: dataObject?.specNumber,
            specRevision: dataObject?.specRevision,
            specType: dataObject?.specType,
            specResponse: dataObject?.specResponse,
            responsibleContractor: dataObject?.responsibleContractor,
            issueContract: formatExportDate(dataObject?.issueContract),
            contractIssuedRelease: formatExportDate(
              dataObject?.contractIssuedRelease,
            ),
            submittalPrepTime: dataObject?.submittalPrepTime,
            submittalRequired: formatExportDate(dataObject?.submittalRequired),
            submittalIssued: formatExportDate(dataObject?.submittalIssued),
            approvalTime: dataObject?.approvalTime,
            submittalApprovalDue: formatExportDate(
              dataObject?.submittalApprovalDue,
            ),
            submittalReturned: formatExportDate(dataObject?.submittalReturned),
            leadTime: dataObject?.leadTime,
            scheduleID: dataObject?.scheduleID,
            dateRequiredOnSite: formatExportDate(
              dataObject?.dateRequiredOnSite,
            ),
            projectedDeliveryDate: formatExportDate(
              dataObject?.projectedDeliveryDate,
            ),
            subCommittedDeliveryDate: formatExportDate(
              dataObject?.subCommittedDeliveryDate,
            ),
            actualDeliveryDate: formatExportDate(
              dataObject?.actualDeliveryDate,
            ),
            custom1: dataObject?.custom1,
            custom2: dataObject?.custom2,
            custom3: dataObject?.custom3,
            custom4: dataObject?.custom4,
            custom5: dataObject?.custom5,
            custom6: dataObject?.custom6,
            custom7: dataObject?.custom7,
            custom8: dataObject?.custom8,
            custom9: dataObject?.custom9,
            custom10: dataObject?.custom10,
            custom11: dataObject?.custom11,
            custom12: dataObject?.custom12,
            custom13: dataObject?.custom13,
            custom14: dataObject?.custom14,
            custom15: dataObject?.custom15,
            custom16: dataObject?.custom16,
            custom17: dataObject?.custom17,
            custom18: dataObject?.custom18,
            custom19: dataObject?.custom19,
            custom20: dataObject?.custom20,
            custom21: dataObject?.custom21,
            custom22: dataObject?.custom22,
            custom23: dataObject?.custom23,
            custom24: dataObject?.custom24,
            custom25: dataObject?.custom25,
            isChildItem: dataObject?.childGroup ? true : false,
          };

          if (
            dataArray.subCommittedDeliveryDate !== "" &&
            dataArray.actualDeliveryDate === ""
          ) {
            const dueDateStatus = checkDueDate(
              dataArray.subCommittedDeliveryDate,
            );
            if (dueDateStatus === "PENDING") {
              dataArray.subCommittedDeliveryDate =
                dataArray.subCommittedDeliveryDate + "applyPending";
            }
            if (dueDateStatus === "OVERDUE") {
              dataArray.subCommittedDeliveryDate =
                dataArray.subCommittedDeliveryDate + "applyLate";
            }
          }

          if (dataArray.dateRequiredOnSite !== "") {
            if (
              dataArray.issueContract !== "" &&
              dataArray.contractIssuedRelease === ""
            ) {
              dataArray.contractIssuedRelease = checkDueDate(
                dataArray.issueContract,
              );
            }
            if (
              dataArray.submittalRequired !== "" &&
              dataArray.submittalIssued === ""
            ) {
              dataArray.submittalIssued = checkDueDate(
                dataArray.submittalRequired,
              );
            }
            if (
              dataArray.submittalApprovalDue !== "" &&
              dataArray.submittalReturned === ""
            ) {
              dataArray.submittalReturned = checkDueDate(
                dataArray.submittalApprovalDue,
              );
            }

            if (dataArray.actualDeliveryDate === "") {
              dataArray.actualDeliveryDate = checkDueDate(
                dataArray.dateRequiredOnSite,
              );
            }
            if (dataArray.projectedDeliveryDate !== "") {
              dataArray.projectedDeliveryDate = checkProjectedDeliveryDate(
                dataArray.projectedDeliveryDate,
                dataArray.dateRequiredOnSite,
              );
            }
          }

          if (dataArray.submittalPrepTime === "") {
            dataArray.submittalPrepTime = parseInt(
              normalizedReviewTime / 7,
              10,
            );
          }
          if (dataArray.approvalTime === "") {
            dataArray.approvalTime = parseInt(normalizedApprovalTime / 7, 10);
          }
          if (dataArray.leadTime === "") {
            dataArray.leadTime = leadTime;
          }

          if (dataObject?.childGroup && nestSubmittals === 1) {
            dataArray.specTitle = `addIndentation** ${dataArray.specTitle}`;
          }
          if (dataObject?.parentGroup && nestSubmittals === 1) {
            dataArray.specTitle = `colorRowToGrey**${dataArray.specTitle}`;
          }

          const finalData = Object.entries(dataArray)
            .filter(([field]) => {
              return (
                resolvedAlignedData[field] &&
                resolvedAlignedData[field].hidden !== "true" &&
                field !== "entryOrigin" &&
                field !== "specTitle" &&
                field !== "specNumber" &&
                field !== "isChildItem"
              );
            })
            .sort(
              ([fieldA], [fieldB]) =>
                (resolvedAlignedData[fieldA]?.index || 0) -
                (resolvedAlignedData[fieldB]?.index || 0),
            )
            .map(([, value]) => value);

          subdivisionData.push([
            dataArray.entryOrigin,
            dataArray.specTitle,
            dataArray.specNumber,
            ...finalData,
          ]);
        }

        const columnDefinitions = [
          { name: " ", key: "entryOrigin" },
          { name: "Item Name", key: "specTitle" },
          { name: "Submittal Number", key: "specNumber" },
          ...Object.entries(resolvedAlignedData)
            .filter(([, value]) => value.hidden !== "true")
            .filter(
              ([field]) =>
                field !== "specTitle" &&
                field !== "specNumber" &&
                field !== "isChildItem",
            )
            .sort(
              ([, left], [, right]) => (left.index || 0) - (right.index || 0),
            )
            .map(([field, value]) => ({
              name: value.label,
              key: field,
            })),
        ];

        const headers = columnDefinitions
          .filter(
            (column) =>
              column.key === "entryOrigin" ||
              resolvedAlignedData[column.key]?.hidden !== "true",
          )
          .map((column) => column.name);

        autoTable(doc, {
          head: [
            [
              {
                content: Object.keys(projectsDetails?.content?.[key] || {})[
                  subdivisionIndex
                ],
                colSpan: headers.length,
              },
            ],
            headers,
          ],
          body: subdivisionData,
          ...tableOptions,
        });
      }
    }

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save(`${resolvedProjectInfo} Procurement Log`);
  };

  const handleExport = () => {
    if (projectsAccessLevelValue < 2 || isExporting) {
      return;
    }

    if (!hasExportStructure) {
      toast.error("No procurement structure is available to export.");
      return;
    }

    const toastId = toast.loading("Exporting procurement log...");
    setIsExporting(true);

    try {
      printTable(exportProjectDetails);
      toast.success("Procurement log exported successfully!", {
        id: toastId,
      });
    } catch (error) {
      console.error("Error exporting procurement log:", error);
      toast.error("Error exporting table. Please try again.", {
        id: toastId,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div
      onClick={handleExport}
      className="d-flex justify-content-left gap-2 align-items-center"
      aria-disabled={projectsAccessLevelValue < 2 || isExporting}
    >
      <FilePdfOutlined style={{ fontSize: "15px" }} />
      Export PDF
    </div>
  );
}

export default ExportProcurementLogPdf;
